<template>
  <div class="gc-levels" :class="{anchor: anchorStyling}">
    <div
      aria-hidden="true"
      class="levels-meter"
      :class="{locked: blurLock}"
      v-if="showLevel">
      <div class="bubbles">
        <div
          class="bubble"
          :key="index"
          :class="{active: l === level, locked: blurLock}"
          v-for="(l, index) of levels" />
      </div>
    </div>
    <span v-if="showLevel" :class="{locked: blurLock}">{{ levelLabel || level }}</span>
    <span :class="{'space-left': true, 'locked': blurLock}">{{ gradeLabelIfAccess }}</span>
  </div>
</template>

<script>
import { getPlaceholderText } from '@/util/placeholder_text'

export default {
  name: 'GoalCardLevelIndicators',
  props: {
    grades: {
      type: Array,
      required: true
    },
    level: {
      type: String,
      default: ''
    },
    levelLabel: {
      type: String,
      default: ''
    },
    levels: {
      type: Array,
      default: () => []
    },
    anchorStyling: {
      type: Boolean,
      default: false
    },
    blurLock: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showLevel() {
      return this.levels && this.levels.length > 0
    },
    gradeLabel() {
      let label = `Grade ${(this.grades.length > 1 &&
        this.grades[0] + '-' + this.grades[this.grades.length - 1]) ||
        this.grades[0]}`

      if (this.grades[0] === 'Birth-3' || this.grades[0] === 'Pre-K') {
        label = label.replace('Grade ', '')
      }
      return label
    },
    gradeLabelIfAccess() {
      if (this.blurLock) {
        return getPlaceholderText(8)
      }
      return this.gradeLabel
    }
  }
}
</script>

<style lang="less" scoped>
@import './colors.less';

.gc-levels {
  display: flex;
  justify-content: space-between;
  align-items: center;

  color: @textPrimary;
  font-size: 10px;
  font-weight: bold;

  .levels-meter {
    margin-right: 1em;
    position: relative;
    height: 0;
    border-bottom: 1px solid @outlinePrimary;

    .bubbles {
      margin-top: -7.5px;
      .bubble {
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        border: 1px solid @outlinePrimary;
        background: @legacyBackground;
        margin-right: 15px;

        &:last-child {
          margin-right: 0;
        }
        &.active {
          background: @outlinePrimary;
        }
        &.locked {
          filter: blur(5px);
        }
      }
    }
    &.locked{
      border-bottom: none;
    }
  }
  &.anchor {
    color: @anchorPrimary;
    .levels-meter {
      border-color: @anchorPrimary;
      .bubbles {
        .bubble {
          border-color: @anchorPrimary;
          background: @anchorBackground;
          &.active {
            background: @anchorPrimary;
          }
        }
      }
    }
  }
  .space-left {
    margin-left: auto;
  }
}
</style>
